import CharCreate from "../../_helper/charcreate";
import {s_char} from "../../_signals/s_char";
import {s_char_attr_step} from "../../_signals/s_char_attr";
import Grid from "@mui/material/Grid";
import {displayAttributeWithMod} from "../../_helper/displayAttributeWithMod";
import CasinoIcon from "@mui/icons-material/Casino";
import ccAttribute from "../../_helper/ccAttribute";
import EditIcon from "@mui/icons-material/Edit";
import React, {Fragment, useState} from "react";
import {
    s_char_mods_cha,
    s_char_mods_ges,
    s_char_mods_str,
    s_char_mods_wah, s_char_mods_wil,
    s_char_mods_zae
} from "../../_signals/s_char_mods";
import {IRollerRoll} from "../../_interfaces/IRoller";
import {rollerSetRoll} from "../../_helper/rollBehave";
import AttributeRaise from "./AttributeRaise";
import {s_app_mobile, s_app_mobile_tab} from "../../_signals/s_app";
import {useSignals} from "@preact/signals-react/runtime";

type Props = {
    attribute: string;
};
export default function AttributeDisplay({attribute}: Props) {
    useSignals();

    const [open, setOpen] = useState(false);

    const ccattr = CharCreate.attributes.filter(e => e.pfield === attribute).shift();
    let label = ccattr!.title + ':';
    if (s_app_mobile.value) label = attribute.toUpperCase();

    const roll = (label, step, attr, canusekarma, karma) => {
        console.log('roll', label, step, attr, canusekarma, karma)
        let step_mod = 0;
        if (attr === 'str') step_mod = s_char_mods_str.value
        if (attr === 'ges') step_mod = s_char_mods_ges.value
        if (attr === 'zae') step_mod = s_char_mods_zae.value
        if (attr === 'cha') step_mod = s_char_mods_cha.value
        if (attr === 'wah') step_mod = s_char_mods_wah.value
        if (attr === 'wil') step_mod = s_char_mods_wil.value
        const roll: IRollerRoll = {
            title: label,
            step: step,
            attribute: attr,
            step_mod: step_mod,
            canusekarma: canusekarma,
            karma: karma,
            strain: 0,
            vs: 0,
            as: '',
            as_fix: false,
            target: [],
            targetVS: ''
        }

        rollerSetRoll(roll, true, false);
    }

    const showDice = () => {
        return (s_app_mobile_tab.value =='roll'&& s_app_mobile)||!s_app_mobile.value
    }

    const showEdit = () => {
        return (s_app_mobile_tab.value =='char'&& s_app_mobile)||!s_app_mobile.value
    }

    return <Fragment>
        <AttributeRaise open={open} setOpen={setOpen} attribute={attribute}></AttributeRaise>
        <Grid item xs={12} style={{textAlign: 'left'}}>
            <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <div style={{fontSize: '1rem'}}>{label} {displayAttributeWithMod(attribute)}</div>
                <div style={{marginLeft: 'auto', display: 'flex'}}>
                    {showDice() ?
                        <>
                            {s_char.value[attribute + '_k'] ?
                                <CasinoIcon
                                    style={{color: 'red', margin: 10}}
                                    onClick={() => roll(
                                        ccAttribute(attribute, 'tt'),
                                        s_char_attr_step(attribute).value,
                                        attribute,
                                        s_char.value[attribute + '_k'],
                                        true
                                    )}/>
                                : null
                            }
                            <CasinoIcon style={{margin: 10}}
                                        onClick={() => roll(
                                            ccAttribute(attribute, 'tt'),
                                            s_char_attr_step(attribute).value,
                                            attribute,
                                            s_char.value[attribute + '_k'],
                                            false
                                        )}/>

                        </>

                        : null}
                    {showEdit() ?<EditIcon style={{margin: 10}} onClick={() => setOpen(true)}/>:null}
                </div>
            </div>
        </Grid>
    </Fragment>
}